module.exports = __webpack_public_path__ + "static/img/jx-yypp.d01164e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-yypp.png
// module id = 1KT+
// module chunks = 0